/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import PropTypes       from 'prop-types';
import { NavLink }     from 'react-router-dom';
import { Colours }     from '../../../styles/variables';
import { Media }       from '../../../styles/utilities';
import { RegularText } from '../../atoms/StyledTypography';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledAnchor = RegularText.withComponent(NavLink).extend`
  color: ${Colours.White};
  text-decoration: none;
  ${Media.Tablet`
    &:hover,
    &.${(props) => props.activeClassName} {
      text-decoration: underline;
    }
  `}
`;

StyledAnchor.propTypes = {
    target: PropTypes.string,
    onAnchorClick: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/atoms/StyledAnchor/index.js